import httpClient from 'shared/lib/httpClient';

/** @returns {{ data: Array<{ id: number, name: string, alias_name?: string, name_short?: string }> }} */
export const getSurgicalPhasesList = async (signal) => {
  const response = await httpClient.get('/surgical-phases', { signal });
  return response?.data;
};
